import { Route, Routes } from "react-router-dom";

import PrivateRoute from "@/private/PrivateRouter";
import LogoutModule from "@/private/modules/logout/index.router";
import PublicRouter from "@/public/PublicRouter";
import useCheckUserLogged from "@rf-hooks/useCheckUserLogged";
import { memo } from "react";
import MxLoading from "@rf-l1/loading/MxLoading";
import { Grid } from "@mui/material";
import { useStatsQuery } from "@/src-refactor/modules/store/qrtk/services/stats/stats.qrtk";

function MainRouter() {
  const { userLogged, userValidatingStatus } = useCheckUserLogged();
  const { } = useStatsQuery({}, {
    skip: !userLogged?.token,
    pollingInterval: 10 * 60 * 1000 // 10 minutos
  })

  if (userValidatingStatus) {
    return (
      <Grid
        container
        justifyContent="center"
        alignItems="center"
        style={{ height: "100vh", width: "100vw" }}
      >
        <MxLoading variant="gradient" type="full screen" />
      </Grid>
    );
  }

  return (
    <Routes>
      <Route
        path="/*"
        element={userLogged?.token ? <PrivateRoute /> : <PublicRouter />}
      />

      <Route path={"/logout/*"} element={<LogoutModule />} />
    </Routes>
  );
}

export default memo(MainRouter);
